import React from "react";
import HomePage from "./HomePage";

function HomePageConnected() {
  return <HomePage />;
}

export default HomePageConnected;
